import React, {useState, useEffect} from 'react';
import Select, { components } from 'react-select';
import { withTranslation } from 'react-i18next';
import "./selectFieldNew.scss";
import AsyncSelect from 'react-select/async';
import {Option} from "../../../models/Option";
import i18next from "i18next";
import BaseField from './baseFieldNew';
import { Placeholder } from 'react-bootstrap';
import { ReactComponent as CloseIcon } from "itd-common/assets/icons/close.svg";

const CustomOption = (props: any) => {
    const handleChange = () => {
        const newValue = !props.isSelected;
        const newSelectedOptions = newValue
            ? [...props.selectProps.value, props.data]
            : props.selectProps.value.filter((option: any) => option.value !== props.data.value);

        props.selectProps.onChange(newSelectedOptions);
    };

    return (
        <components.Option {...props}>
            <input  hidden={props.data.value === "filterToViewMore"||!props.selectProps.isMulti}
                type="checkbox"
                className='w-10'
                checked={props.isSelected}
                onChange={handleChange}
            />{" "}
            {props.data.value === "filterToViewMore"?<span style={{color:"gray"}}>{props.label}</span>:props.label}
        </components.Option>
    );
};

const CustomMultiValue = (props: any) => {
  const { index, getValue, data } = props;
    const maxToShow = 1;
    const overflow = getValue().length - maxToShow;

    // if (data?.value === "") return null; // ocultar chip "Ver todos"
  if (index < maxToShow) return <components.MultiValue {...props} />;
  if (index === maxToShow) {
    return (
      <components.MultiValue {...props}>
        <span className="counter-label">+ {overflow}</span>
      </components.MultiValue>
    );
  }
    if (index === maxToShow) {
        return (
            <components.MultiValue {...props}>
              <span className="counter-label">+ {overflow}</span>
            </components.MultiValue>
        );
    }

    return null;
};

const MultiSelectField = ({ attr, label, options, selectedOptions, setSelectedOptions,multiSelect }: {attr:any, label:any, options:Option[], selectedOptions:any, setSelectedOptions:any,multiSelect:boolean}) => {
    const [defaultOptions, setDefaultOptions] = useState<Option[]>([]);
    const selectSinglePlaceHolder: string= i18next.t("common.action.select");

    const handleChange = (selected: any) => {
        if(multiSelect){
            const values = selected ? selected.map((option: any) => option.value) : [];
            setSelectedOptions(values);
        }else{
            const values = selected ? [selected.value] : [];
            setSelectedOptions(values);
        }
    };

    useEffect(() => {
        // Update defaultOptions when options change
        promiseOptions("").then((res)=>{
        setDefaultOptions(res);
        });
    }, [options]);
   
    const selectedValues = selectedOptions || []; 
    const hasRealSelection =
    multiSelect
      ? selectedValues.some((v:any) => v !== "")
      : (selectedValues[0] ?? "") !== "";

    const customStyles = {
        option: (provided:any) => ({
            ...provided,
            display: 'inline-flex',
        }),
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }), // evita que el calendario/tabla quede por encima del listado
        menu: (base: any) => ({ ...base, zIndex: 9999 }),
         dropdownIndicator: (base: any) => ({
          ...base,
          color: 'black', 
          svg: { fill: 'black' }
        }),
        clearIndicator: (base: any) => ({
          ...base,
          color: 'black', 
          svg: { fill: 'black' },
          ...(!hasRealSelection && {
            display: 'none'
          })
        }),
        indicatorsContainer: (base: any) => ({
          ...base,
          flexDirection: 'row-reverse',
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          gap: 4,
        }),
        container: (base: any) => ({
            ...base,
            width: '100%', 
        }),
        placeholder: (base: any) => ({
            ...base,
            lineHeight: '40px', 
        }),
        
        multiValue: (base:any, state:any) => ({
          ...base,
          backgroundColor: 'transparent', 
          border: 'none',
          boxShadow: 'none',
          padding: 0,
          margin: '2px 4px',       
        }),
        multiValueLabel: (base: any, state: any) => ({
            ...base,
            color: hasRealSelection ? 'black' : '#9D9B9B',
            fontSize: '14px'
          }),
        control: (base: any, state: any) => ({
          ...base,
          width: "100%",
          minHeight: 40,
          height: 40,
          borderStyle: 'solid',
          borderRadius: 12,
          
          borderWidth: hasRealSelection ? 1.7 : 1.5,
          // BASE: invisible en Ver todos, negro si hay selección real
          borderColor: hasRealSelection ? 'black' : '#CECECE',
          boxShadow: 'none',
          outline: 'none',

          ...(state.isFocused && {
            borderColor: 'black',
            borderWidth: 1.7,
            boxShadow: 'none',
            outline: 'none',
            cursor: 'pointer'
          }),
          ...(state.isFocused && {
            borderColor: 'black',
            borderWidth: 1.7
          }),
          "&:hover": {
            borderColor: 'black',
            borderWidth: 1.7,
            cursor: 'pointer'
          }
          }),
          multiValueRemove: (base: any) => ({
            ...base,
            display: "none",
          }),
    };
    
    const promiseOptions = (inputValue: string) =>
        new Promise<Option[]>((resolve) => {
            var res=[];
            for(var i in options){
                if((options[i].label+"").toUpperCase().indexOf(inputValue.toUpperCase())==0)
                    res.push(options[i]);
                if(res.length>50){
                    res.push({label:i18next.t("filterToViewMore"),value:"filterToViewMore"});
                    break;
                }
            }
            resolve(res);

    });
    const getClassOfTypeMultiselect = () =>{
        let value= (!multiSelect ? "container-multiselect-new singleSelect" : "container-multiselect-new");
        return value;
    }
    const ClearIndicator = (props: any) => {
      const { innerProps } = props;
    
      return (
        <components.ClearIndicator {...props}>
          {/* se mantiene innerProps para click/hover/aria */}
          <div {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
            <CloseIcon color='black' height='18' width='18'/>
          </div>
        </components.ClearIndicator>
      );
    };

    return (
        <BaseField attr={attr} label={label} value={selectedValues} disabledBorder={true} hideSingleClearState={true}>
            <div className={getClassOfTypeMultiselect()}>
                <AsyncSelect loadOptions={promiseOptions}
                    defaultOptions={defaultOptions}
                    hideSelectedOptions={false}
                    isMulti={multiSelect}
                    // isSearchable
                    closeMenuOnSelect={!multiSelect}
                    placeholder={!multiSelect && selectSinglePlaceHolder}
                    onChange={handleChange}
                    value={options.filter((option: any) => selectedValues.includes(option.value))}
                    components={{ Option: CustomOption, MultiValue: CustomMultiValue, ClearIndicator: ClearIndicator }}
                    inputId={attr}
                    className={`w-100`}
                    styles={customStyles}
                    noOptionsMessage={() => 'No hay opciones'}
                />
            </div>
        </BaseField>

        );
};

export default withTranslation()(MultiSelectField); 